/* eslint-disable camelcase */
import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  organisator_types: [],
  organisator_type: null
}

// mutations
export const mutations = {
  [types.SET_ORGANISATOR_TYPES] (state, organisator_types) {
    state.organisator_types = organisator_types
  },
  [types.SET_ORGANISATOR_TYPE] (state, organisator_type) {
    state.organisator_type = organisator_type
  },
  [types.FETCH_ORGANISATOR_TYPE_FAILURE] (state) {
    state.organisator_type = null
  }
}

// actions
export const actions = {
  async fetchOrganisatorTypes ({ commit }) {
    try {
      const { data } = await axios.get('/api/organisator_types')
      commit(types.SET_ORGANISATOR_TYPES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchOrganisatorType ({ commit }, organisator_type) {
    try {
      const { data } = await axios.get(`/api/organisator_types/${organisator_type.id}`)

      commit(types.SET_ORGANISATOR_TYPE, { organisator_type: data })
    } catch (e) {
      commit(types.FETCH_ORGANISATOR_TYPE_FAILURE)
    }
  },

  async createOrganisatorType (context, organisator_type) {
    try {
      console.log({ organisator_type })
      await axios.post('/api/organisator_types', organisator_type)
      context.dispatch('fetchOrganisatorTypes')
    } catch (e) {
      console.log(e)
    }
  },

  async updateOrganisatorType (context, organisator_type) {
    try {
      await axios.put(`/api/organisator_types/${organisator_type.id}`, organisator_type)
      context.dispatch('fetchOrganisatorTypes')
    } catch (e) { }
  },

  // eslint-disable-next-line camelcase
  async deleteOrganisatorType (context, organisator_type) {
    try {
      await axios.delete(`/api/organisator_types/${organisator_type.id}`)
      context.dispatch('fetchOrganisatorTypes')
    } catch (e) { }
  }
}

// getters
export const getters = {
  organisator_types: state => state.organisator_types
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/organisator-type.js